import React, { useState, useEffect } from "react";
import { Layout, Menu, Row, Col, Button } from "antd";
import {
  GlobalOutlined,
  PhoneOutlined,
  HomeOutlined,
  MailOutlined,
} from "@ant-design/icons";
import Burger from "@animated-burgers/burger-slip";
import "@animated-burgers/burger-slip/dist/styles.css";
import classNames from "classnames";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";

import Analytics from "./common/Analytics";
import Cluar from "./common/Cluar";
import Builder from "./common/Builder";
import Cookies from "./components/Cookies";
import NotFound from "./pages/NotFound";

import "./styles/App.less";

const { Header, Content, Footer } = Layout;
const { SubMenu } = Menu;

export default () => {
  const storageLocale = window.localStorage.getItem("locale");
  if (storageLocale == null) {
    window.localStorage.setItem("locale", Cluar.currentLanguage().locale);
  } else {
    Cluar.changeLanguage(storageLocale);
  }

  const [burgerMenu, setBurgerMenu] = useState(false);
  const [activeMenu, setActiveMenu] = useState("main");
  const [locale, setLocale] = useState(Cluar.currentLanguage().locale);

  const handleMenuClick = (selectMenu) => {
    setBurgerMenu(false);
    if (selectMenu) {
      setActiveMenu(selectMenu);
    }
    window.scrollTo(0, 0);
  };

  const menuLanguages = [];
  const menu = [];
  const subMenuKeys = [];
  const routes = [];
  for (const language of Cluar.languages()) {
    if (!Cluar.pages()[language.code]) {
      continue;
    }
    if (language.code !== Cluar.currentLanguage().code) {
      menuLanguages.push(
        <Menu.Item
          key={language.code}
          onClick={() => {
            Cluar.changeLanguage(language.locale);
            window.localStorage.setItem(
              "locale",
              Cluar.currentLanguage().locale
            );
            window.location.href = `/${language.locale}/`;
          }}
        >
          {language.description}
        </Menu.Item>
      );
    }

    const buildMenu = (page) => {
      if (page.menu && language.code === Cluar.currentLanguage().code) {
        const key = `${page.link}`;
        if (
          Cluar.pages()[language.code].find(
            (p) => p.menu && p.parent === page.link
          )
        ) {
          subMenuKeys.push(key);
          return (
            <SubMenu
              key={key}
              title={
                page.navigable ? (
                  <Link
                    to={`/${Cluar.currentLanguage().locale}${page.link}`}
                    onClick={() => handleMenuClick(key)}
                  >
                    {page.title}
                  </Link>
                ) : (
                  <a>{page.title}</a>
                )
              }
            >
              {Cluar.pages()
                [language.code].filter((p) => p.menu && p.parent === page.link)
                .map((p) => buildMenu(p))}
            </SubMenu>
          );
        } else {
          return (
            <Menu.Item key={key}>
              {page.navigable ? (
                <Link
                  to={`/${Cluar.currentLanguage().locale}${page.link}`}
                  onClick={() => handleMenuClick(key)}
                >
                  {page.title}
                </Link>
              ) : (
                <a>{page.title}</a>
              )}
            </Menu.Item>
          );
        }
      }
      return null;
    };

    const subroutes = [];
    for (const page of Cluar.pages()[language.code]) {
      if (
        page.menu &&
        page.parent === "" &&
        language.code === Cluar.currentLanguage().code
      ) {
        menu.push(buildMenu(page));
      }
      if (page.navigable == false) {
        continue;
      }
      subroutes.push(
        <Route
          key={`/${language.locale}${page.link}`}
          exact
          path={`/${language.locale}${page.link}`}
          exact
          render={(propRouter) => {
            return <Builder page={page} />;
          }}
        />
      );
    }
    routes.push(
      <Route key={`/${language.locale}/`} path={`/${language.locale}/`}>
        {subroutes}
      </Route>
    );
  }

  useEffect(() => {}, []);

  return (
    <Router>
      {Analytics.init() && <Analytics.RouteTracker />}
      <div className="page">
        <Layout>
          <Header className={classNames({ "header-burger-open": burgerMenu })}>
            <div className="logo">
              <a href="https://www.eeagrants.gov.pt/pt/" target="_blank">
                <img alt="logo" src="/images/logos_footer/EEA_grants.png" />
              </a>
            </div>
            <div className="logo">
              <Link
                to={`/${Cluar.currentLanguage().locale}/`}
                onClick={() => handleMenuClick("/")}
              >
                <img alt="logo" src="/images/logo.png" />
              </Link>
            </div>
            <div
              className={classNames({
                menu: true,
              })}
            >
              <Menu
                theme="light"
                mode="horizontal"
                defaultSelectedKeys={[activeMenu]}
                selectedKeys={[activeMenu]}
              >
                {menu}
              </Menu>
              <div
                className={classNames({
                  "menu-button": true,
                })}
              >
                <Button
                  className="button_plataform"
                  // onClick={() =>
                  //   window.open("https://my.cplusd-platform.pt/", "_blank")
                  // }
                >
                  C+D Platform (soon)
                </Button>
              </div>
            </div>
            <div
              className={classNames({
                menu: true,
                "menu-burger": true,
                "menu-burger-open": burgerMenu,
              })}
            >
              <Menu
                theme="light"
                mode="inline"
                defaultSelectedKeys={[activeMenu]}
                selectedKeys={[activeMenu]}
                defaultOpenKeys={subMenuKeys}
              >
                <Menu.Item>
                  <Button className="button_plataform">C+D Plataform</Button>
                </Menu.Item>
                {menu}
              </Menu>
            </div>
            <div className="menu-burger-button">
              <Burger
                isOpen={burgerMenu}
                onClick={() => {
                  setBurgerMenu(!burgerMenu);
                }}
              />
            </div>
            <Menu
              theme="light"
              className="menu-languages"
              mode={"horizontal"}
              defaultSelectedKeys={[activeMenu]}
              selectedKeys={[activeMenu]}
            >
              <SubMenu
                icon={<GlobalOutlined />}
                title={Cluar.currentLanguage().code}
              >
                {menuLanguages}
              </SubMenu>
            </Menu>
          </Header>
          <Content>
            <Switch>
              <Route
                path="/"
                exact
                render={(propRouter) => {
                  return (
                    <Redirect to={`/${Cluar.currentLanguage().locale}/`} />
                  );
                }}
              />
              {routes}
              <Route component={NotFound} />
            </Switch>
          </Content>
          <Cookies />
        </Layout>
      </div>
    </Router>
  );
};
